import { useAgentChatContext } from '@ltvco/refresh-lib/ctx';
import { useSession } from '@ltvco/refresh-lib/v1';
import {
  AgentChatDrawer,
  AgentChatLauncher,
  useVehicleFinder,
  useVehicleVetter,
} from '@ltvco/refresh-lib/v2';
import { useCallback } from 'react';

export const AgentChatSurface = () => {
  const {
    session: { account },
  } = useSession();
  const { isOpen, vehicle, openChat, closeChat } = useAgentChatContext();

  const userId = account?.account?.user_info?.user_code ?? '';

  // Hooks are lifted here (not inside the drawer) so the conversation
  // survives open/close cycles.
  const finder = useVehicleFinder(userId);
  const vetter = useVehicleVetter(userId);

  // Wrapped so the click event is never forwarded as a queued message.
  const handleLauncherClick = useCallback(() => openChat(), [openChat]);

  if (!userId) {
    return null;
  }

  return (
    <>
      <AgentChatLauncher onClick={handleLauncherClick} />
      <AgentChatDrawer
        open={isOpen}
        onClose={closeChat}
        finder={finder}
        vetter={vetter}
        vehicleIdentifier={vehicle?.vehicleIdentifier}
        vehicleTitle={vehicle?.vehicleTitle}
      />
    </>
  );
};
